import React, { Dispatch } from 'react';
import Translator from '../../../../../core/i18n';
import { Log } from 'ng2-logger';
import { Common } from '../../../../../core/common';
import { IAppState, IAction } from '../../../../../models/action/core';
import { connect } from 'react-redux';
import { IHeaderProps } from '../../../../../models/components/activity-card-survey';

const T = Translator.create();
const _logger = Log.create('Survey Header');
let _common: Common;
class Header extends React.Component<IHeaderProps> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    public render() {
        return (
            <div className="w-100">
                <div className="survey_question">
                    <textarea
                        name="survey_header"
                        className="survey_input card-q"
                        id="survey_header"
                        cols={30}
                        rows={1}
                        disabled={true}
                        value={this.props.question.description}
                        style={{textAlign: 'justify', fontWeight:'bold',  height: 'auto', resize: 'none' }}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IHeaderProps): IHeaderProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IHeaderProps = Object.assign({}, ownProps, {
        surveyChoices: state.coursePage.surveyChoices
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.coursePage.surveyChoices === prev.coursePage.surveyChoices
    );
    return ret;
};

const CHeader = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(Header);

export default CHeader;

